import React from 'react'
import { Box, BoxProps, Text } from '@chakra-ui/react'
import SharedStack from '../wrappers/shared-stack'

interface Props extends BoxProps {
    icon?: React.ReactNode
    label: string
    description: string
}

export default function MenuOptionWthDescription({
    icon,
    label,
    description,
    ...props
}: Props) {
    return (
        <Box {...props}>
            <SharedStack row fit>
                {icon && icon}
                <Text fontWeight="semibold" fontSize="sm">
                    {label}
                </Text>
            </SharedStack>
            <Text fontSize="xs" color="gray.600" textOverflow="wrap">
                {description}
            </Text>
        </Box>
    )
}
